<template>
    <div>
        <DialogoLogout :key="this.dialogoLogoutKey" :countdown="this.countdown" :timeout="this.countdown" ref="logout"
            :titulo="this.titulo" :width="this.width" />
        <DialogoMenu ref="dialMenu"></DialogoMenu>
        <DialogoPreAfi ref="refModDatos" titulo="Editar mi legajo" type="modificacion" />
        <DialogoFaltaFoto ref="refDialogoActualizaFoto" type="foto" @irAEditar=despliegaDialogoEditar />
        <DialogoFaltaFoto ref="refDialogoActualizaContacto" type="contacto" />
        <!--  <DialogoFaltaFoto ref="refDialogoActualizaFoto" type="foto" />
        <DialogoFaltaFoto ref="refDialogoActualizaContacto" type="contacto" /> -->
        <v-app-bar app clipped-left flat dark height="80" color="primary">
            <v-btn v-if="$vuetify.breakpoint.mdAndDown" icon @click="desplegarDialogo" class="mr-1">
                <v-icon>mdi-menu</v-icon>
            </v-btn>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="goToHome" text height="90" v-bind="attrs" v-on="on" class="ma-0 pa-0">
                        <v-img :max-width="$vuetify.breakpoint.xsOnly ? 190 : 240" src="@/assets/Logo-bt-06.png" />
                    </v-btn>
                </template>
                <span>Ir a Mi legajo</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <UserLogNav />
        </v-app-bar>
        <!-- Oculta Drawer en las  vistas   -->
        <div
            v-if="(currentRouteName !== 'union-convivencial') && (currentRouteName !== 'maternidad') && (currentRouteName !== 'madre_no_gestante') && (currentRouteName !== 'adopcion') && (currentRouteName !== 'matrimonio') && (currentRouteName !== 'nacimiento')">
            <Drawer ref="refDrawer" />
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import DialogoMenu from '@/components/dialogos/DialogoMenu.vue';
import menuNotify from '@/components/navigations/menuNotify.vue'
import UserLogNav from '@/components/navigations/UserLogNav.vue'
import Drawer from '@/components/navigations/Drawer.vue'
import DialogoLogout from '@/components/dialogos/DialogoLogout.vue';
import DialogoFaltaFoto from '@/components/dialogos/DialogoFaltaFoto.vue';
import DialogoPreAfi from '@/components/dialogos/DialogoPreAfi.vue';

export default {
    components: {
        menuNotify,
        UserLogNav,
        Drawer,
        DialogoMenu,
        DialogoFaltaFoto,
        DialogoPreAfi,
        DialogoLogout
    },
    data() {
        return {
            titulo: '',
            width: 600,
            tipo: '',
            intervalId: null,
            countdown: 60000,
            dialogoLogoutKey: 0,
            isActive: false,

            tipoFalta: '',

        }
    },
    watch: {

        pedirFoto(newVal, oldVal) {
            this.checkDialogosReady();
        },
        pedirDatosContacto(newVal, oldVal) {
            this.checkDialogosReady();
        },
        /*         $route(to) {
                    // Verificar si la ruta es 'dashboard' y si el usuario está autenticado
                    if (to.name == 'dashboard' && this.isAuthenticated) {
                        this.$nextTick(() => {
                            this.checkDialogosReady()
                        });
                    }
                } */

        /*  pedirDatosContacto(newVal) {
             if (newVal == 1 && this.pedirFoto != 1) {
                 // Mostrar el diálogo de contacto solo si el de foto no está activo
                 this.$refs.refDialogoActualizaContacto.abrirDialogo();
             }
         }, */
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'emailAuth', 'user', 'tiempoRestante', 'nroafi', 'pedirFoto', 'pedirDatosContacto']),
        currentRouteName() {
            return this.$route.name
        },
        pronombre() {
            switch (this.user.sexo) {
                case "M":
                    return "Afiliado"
                case "F":
                    return "Afiliada"
                default:
                    return "Afiliadx"
            }
        },
    },
    methods: {
        ...mapActions('auth', ['getUser', 'cerrarSesion', 'decodeToken']),

        reinicioDialogoLogout() {
            this.forceRender()
        },

        despliegaDialogoEditar(value) {
            this.$refs.refModDatos.abrirDialogo(value)
        },
        // metodo que despliega los dialogos segun datos faltantes del afiliado
        /* verificarDialogos() {
            if (this.pedirFoto == 1 && this.pedirDatosContacto == 1) {
                // Muestra primero el diálogo de falta de foto y luego el de contacto
                this.$refs.refDialogoActualizaFoto.abrirDialogo();
                this.$refs.refDialogoActualizaContacto.abrirDialogo();
            } else if (this.pedirFoto == 1) {
                // Muestra solo el diálogo de falta de foto
                this.$refs.refDialogoActualizaFoto.abrirDialogo();
            } else if (this.pedirDatosContacto == 1) {
                // Muestra solo el diálogo de falta de contacto
                this.$refs.refDialogoActualizaContacto.abrirDialogo();
            }
        }, */
        desplegarDialogo() {
            this.$refs.dialMenu.abrirDialogo()
        },
        forceRender() {
            this.dialogoLogoutKey += 1;
        },
        lanzarDialogo() {
            this.titulo = '¿Estás ahí?'
            this.width = 600
            this.$refs.logout.abrirDialog()
        },
        lanzarDialogoActualizar() {
            this.tipoFalta = 'contacto'
            this.$refs.refDialogoActualiza.abrirDialogo()
        },
        comprobarCaducidadSesion() {
            let tiempoAlertaSesion = 1
            let tiempoRestante = this.tiempoRestante()
            console.log(tiempoRestante + ' restantes ..')
            if (tiempoRestante === -1) return;
            if (tiempoRestante == tiempoAlertaSesion) {
                if (this.isActive == false)
                    this.lanzarDialogo()
                this.isActive = true
            }
            else {
                this.isActive = false
                if (tiempoRestante <= 0)
                    this.cerrarSesion()
            }
        },
        goToHome() {
            this.$router.push('/dashboard').catch(() => { })
        },
        checkDialogosReady() {
            // Ejecutar en Dashboard; los flags se normalizan en verificarDialogos
            if (this.$route.name === 'dashboard') {
                this.verificarDialogos();
            }
        },

        toBoolFlag(value) {
            if (value === 1 || value === '1' || value === true) return true;
            if (typeof value === 'string') {
                const v = value.trim().toLowerCase();
                return v === 'true' || v === 'si' || v === 'sí' || v === 's';
            }
            return false;
        },

        async verificarDialogos() {
            const refFoto = this.$refs.refDialogoActualizaFoto;
            const refContacto = this.$refs.refDialogoActualizaContacto;
            const pedirFoto = this.toBoolFlag(this.pedirFoto);
            const pedirDatosContacto = this.toBoolFlag(this.pedirDatosContacto);

            if (pedirFoto && pedirDatosContacto) {
                if (refFoto && refFoto.abrirDialogo && refContacto && refContacto.abrirDialogo) {
                    await refFoto.abrirDialogo();
                    await refContacto.abrirDialogo();
                }
            }
            else if (pedirDatosContacto) {
                if (refContacto && refContacto.abrirDialogo) {
                    await refContacto.abrirDialogo();
                }
            }
            else if (pedirFoto) {
                if (refFoto && refFoto.abrirDialogo) {
                    await refFoto.abrirDialogo();
                }
            }
        },
    },
    mounted() {

        this.$nextTick(() => {
            this.checkDialogosReady();
        });

        this.getUser({ nroafi: this.nroafi, bit: 0 }).then(() => {
            // Cargar email después de cargar el usuario
            this.$store.dispatch('getEmail');
            this.$nextTick(() => {
                this.checkDialogosReady();
            });
        })
        if (sessionStorage.getItem('token')) {
            this.intervalId = window.setInterval(() => {
                this.comprobarCaducidadSesion()
            }, 1000)
        }
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    },
}
</script>